import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import { NurseryCalculator } from "./components/nursery-calculator/nursery-calculator";
import { BikesCalculatorPage } from "./pages/bikes-calculator-page";
import { defaultTheme } from "./themes";
import "./themes/fonts.css";

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/nursery-savings-funding-calculator/"
            element={<NurseryCalculator />}
          />
          <Route path="*" element={<BikesCalculatorPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
